module.exports = __webpack_public_path__ + "img/cx.a59227af.png";